import type { WeeklyShift } from "@opus-dt/shared-types";

// Conversões hora-local ↔ minuto-do-dia para o editor de expediente. Puras;
// reusadas pelo editor da linha e pelo seletor de calendário do cenário.

export const WEEKDAYS = [
  { value: 0, short: "Dom", long: "Domingo" },
  { value: 1, short: "Seg", long: "Segunda" },
  { value: 2, short: "Ter", long: "Terça" },
  { value: 3, short: "Qua", long: "Quarta" },
  { value: 4, short: "Qui", long: "Quinta" },
  { value: 5, short: "Sex", long: "Sexta" },
  { value: 6, short: "Sáb", long: "Sábado" },
] as const;

export function minutesToTime(min: number): string {
  const m = ((min % 1440) + 1440) % 1440;
  const hh = Math.floor(m / 60);
  const mm = m % 60;
  return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`;
}

export function timeToMinutes(hhmm: string): number {
  const [h, m] = hhmm.split(":").map((n) => Number(n) || 0);
  return (h ?? 0) * 60 + (m ?? 0);
}

// Forma de edição de um turno: hora de início/fim locais. "Cruza a meia-noite" é DERIVADO da
// comparação (fim < início ⇒ vira o dia: 22h→06h), sem flag extra na UI.
export interface ShiftForm {
  weekday: number;
  startTime: string; // "HH:mm"
  endTime: string; // "HH:mm"
  label?: string;
}

export function toShiftForm(shift: WeeklyShift): ShiftForm {
  return {
    weekday: shift.weekday,
    startTime: minutesToTime(shift.startMinute),
    endTime: minutesToTime(shift.endMinute), // % 1440 embutido ⇒ endMinute 1800 vira "06:00"
    label: shift.label,
  };
}

// Constrói a entidade a partir da forma. fim > início ⇒ mesmo dia; fim < início ⇒ atravessa a
// meia-noite (endMinute = fim + 1440, garante > startMinute — exigência do schema). fim == início
// ⇒ null (duração ambígua/zero) — a UI sinaliza a linha.
export function fromShiftForm(form: ShiftForm): WeeklyShift | null {
  const startMinute = timeToMinutes(form.startTime);
  const endWithinDay = timeToMinutes(form.endTime);
  if (endWithinDay === startMinute) return null;
  const endMinute = endWithinDay > startMinute ? endWithinDay : endWithinDay + 1440;
  const label = form.label?.trim();
  return { weekday: form.weekday, startMinute, endMinute, ...(label ? { label } : {}) };
}
